export const TOOLTIP_DELAY = 0.5 as const;
export const TOPBAR_HEIGHT = 51 as const; // Needs to be adjusted if topbar height changes
export const TOPBAR_BUTTON_ICON_HEIGHT = 19 as const;
